import { API_BASE_URL } from '../config'

export type EventType = 'view' | 'download'

export const trackCaseEvent = async (caseId: number, eventType: EventType) => {
  try {
    await fetch(`${API_BASE_URL}/api/stats/cases/${caseId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType })
    })
  } catch (error) {
    console.error('Failed to track case event:', error)
  }
}

export const trackReportEvent = async (reportId: number, eventType: EventType) => {
  try {
    await fetch(`${API_BASE_URL}/api/stats/reports/${reportId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType })
    })
  } catch (error) {
    console.error('Failed to track report event:', error)
  }
}
